import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import BaseViewer from './Base';
import omit from 'lodash/omit';
import mergeTheme from '../Themes/mergeTheme';
import customboxTheme from '../Themes/Viewer/custombox.scss';
class CustomBoxViewer extends React.Component {
    render() {
        const restProps = omit(this.props, [
            'theme'
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            className: 'da-editor-custombox'
        }, /*#__PURE__*/ React.createElement(BaseViewer, _extends({
            theme: this.theme,
            showMediaAlwaysSmall: false,
            fixedParagraph: false
        }, restProps)));
    }
    constructor(props){
        super(props);
        this.theme = mergeTheme(customboxTheme, this.props.theme);
    }
}
export { CustomBoxViewer as default };
